export default {
  share: {
    'fullUrl': 'Completa',
    'shortUrl': 'Breve',
    'urlCopied': 'URL copiata.',
    'clickToCopy': 'Clicca per copiare la URL',
    'share': 'Condividi (clicca per copiare)',
    'shareLink': 'Condividi link',
    'short': 'Accorcia URL',
    'copyUrlInfo': 'Puoi anche copiare il link dalla barra degli indirizzi del tuo browser.',
    'urlShortened': 'URL accorciata',
    'shorteningNotPossible': 'Non è stato possibile accorciare la URL. Usa la URL completa',
    'embedCodeCopied': 'Codice per l\'integrazione copiato',
    'embed': 'Integrazione in altri siti internet (clicca per copiare)',
    'embedInstructions': 'Usa questo codice per integrare ORS map nel tuo sito internet'
  }
}
